<template>
    <div class="container">
        <h1>Configure Rooms</h1>
        <b-tabs position="is-centered" class="block" v-model="activeTab">
            <b-tab-item label="List">
                <app-room-list :rooms="rooms"></app-room-list>
            </b-tab-item>
            <b-tab-item label="Floors">
                <app-floor-list :floors="floors"></app-floor-list>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import RoomList from '../components/configure/RoomList';
    import FloorList from '../components/configure/FloorList';

  export default {
    name: "screenconfigurerooms",
    components: {
      appRoomList: RoomList,
      appFloorList: FloorList
    },
    data() {
      return {
        activeTab: 0
      };
    },
    computed: {
      ...mapGetters('ui', ['loadingOverlay']),
      ...mapGetters('auth', ['hasPermission']),
      ...mapGetters('rooms', ['rooms', 'floors'])
    },
    methods: {
      hasConfigurePermission(permissionId) {
        return this.hasPermission(permissionId);
      }
    },
    mounted() {

    }
  }
</script>

<style scoped>
h1 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
}
</style>